<div class="wholePage" >
  <div *ngIf="!review" class="leftPortion" >
    <div class="steps">
      <p class="formTitle" >
        Registration Form
      </p>
      <div style="width:100%;display: flex;align-items: center;gap:16px" >
      <div class="progressBar">
      <div class="progressBarFill" [style.width.%]="progressBar"></div>

      </div>
      <div class="progressNumber" >{{progressBar/25}}/4</div>
    </div>
      <div>
        <app-progress [activeIndex]="activeIndex" [steps]="steps"></app-progress>
      </div>
      <!-- <button (click)="onBack()">Back</button> -->
      <!-- <button (click)="onNext()">Next</button> -->

    </div>
  </div>

  <div *ngIf="!review" #rightPortion class="rightPortion">
    <img *ngIf="activeIndex!=0" style="z-index: 10000;margin-bottom: 16px;cursor: pointer;" src="../../../assets/images/arrowBack.svg" (click)="onBack()" alt=""/>
    <div *ngIf="activeIndex==0" class="section" >
      <p class="sectionTitle" >General Information بيانات عامة</p>
      <div  class="subsection">
      <p class="formLabel">
        Education institution Name - اسم المنشأة التعليمية/الاسم التجاري
          </p>
          <!-- <mat-form-field  class="formFieldMaro"  [hideRequiredMarker]="true" appearance="outline">

            <input matInput placeholder="Student Id" style="border: grey;color: yellow;" >

          </mat-form-field> -->
          <input class="formFieldMaro"  >
        </div>
        <div class="subsection">
          <p class="formLabel">
            Company Name - اسم الشركة (As Per The Commercial Register - مطابق للسجل التجاري)
              </p>
              <input class="formFieldMaro"  >
        </div>
        <div class="subsection">
          <p class="formLabel">
            Authorized Person - الشخص المفوض (As Per The Commercial Register - مطابق للسجل التجاري)
              </p>
              <input class="formFieldMaro"    >
        </div>
        <div class="subsection">
          <p class="formLabel">
            Title - المنصب
              </p>
              <input class="formFieldMaro"    >
        </div>
        <div class="subsection">
          <p class="formLabel">
            Commercial Register Number - رقم السجل التجاري (As Per The Commercial Register - مطابق للسجل التجاري)
              </p>
              <input class="formFieldMaro"    >
        </div>
        <div class="subsection">
          <p class="formLabel">
            Tax Card Number - رقم البطاقة الضریبیة (As Per The Tax ID - مطابق للبطاقة الضریبیة)
              </p>
              <input class="formFieldMaro"    >
        </div>
        <div class="subsection">
          <p class="formLabel">
            Company Address - عنوان الشركة (As Per The Commercial Register - مطابق للسجل التجاري)
              </p>
              <input class="formFieldMaro"    >
        </div>
        <p style="margin-top:8px ;" class="sectionTitle" >Business Activity بيانات نشاط الشركة</p>
        <div class="subsection">
          <p class="formLabel">
            Number of students that will be registered on the system - عدد الطلبة الذي سیتم تسجیلهم علي المنصة
              </p>
              <input class="formFieldMaro"  >

        </div>
        <div class="subsection">
          <p class="formLabel">
            Number of Branches - عدد الافرع
              </p>
              <input class="formFieldMaro"  >

        </div>
        <div class="subsection">
          <p class="formLabel">
            Average annual fees collected per student - متوسط المصروفات السنویة المحصلة من كل طالب
              </p>
              <input class="formFieldMaro"  >

        </div>
        <div class="nextButton" (click)="onNext()"  style="margin-top: 8px;">
          Next
        </div>


    </div>

    <div *ngIf="activeIndex ==1" class="section" >
      <p class="sectionTitle" >Financials Contact Person Details - بیانات مسئول الماليات</p>
      <div  class="subsection">
      <p class="formLabel">
        Name - الاسم
          </p>
          <input class="formFieldMaro"  >
        </div>
        <div class="subsection">
          <p class="formLabel">
            Mobile Number - رقم المحمول
              </p>
              <input class="formFieldMaro"  >
        </div>
        <div class="subsection">
          <p class="formLabel">
            Email - البرید الالكتروني
              </p>
              <input class="formFieldMaro"    >
        </div>

        <p style="margin-top:8px ;" class="sectionTitle" >Notices - الاخطارات</p>
        <div class="subsection">
          <p class="formLabel">
            Notices Address - عنوان الاخطارات
              </p>
              <input class="formFieldMaro"  >

        </div>
        <div class="subsection">
          <p class="formLabel">
            Contact Person - الشخص المسئول
              </p>
              <input class="formFieldMaro"  >

        </div>
        <div class="subsection">
          <p class="formLabel">
            Mobile Number - رقم المحمول
              </p>
              <input class="formFieldMaro"  >

        </div>
        <div class="subsection">
          <p class="formLabel">
            Email - البرید الالكتروني
              </p>
              <input class="formFieldMaro"  >

        </div>
        <div class="nextButton" (click)="onNext()"  style="margin-top: 8px;">
          Next
        </div>
    </div>

    <div *ngIf="activeIndex==2" class="section">
      <p class="sectionTitle" >Branches Bank Info</p>
      <div class="tableBackground" >
<div class="tableBox none" style="width: 100%; display: flex; justify-content: center; flex-direction: column;">


  <div #sourceWidth ngClass="tableTitles" *ngIf="dataSource?.data != null && dataSource?.data.length > 0">
    <p i18n ngClass="tableHead" style="width: calc(100% / 9);" >Branch Number</p>
    <p i18n ngClass="tableHead" style="width: calc(100% / 9);" >Branch Name-English</p>
    <p i18n ngClass="tableHead" style="width: calc(100% / 9);" >اسم الفرع بالعربية</p>
    <p i18n ngClass="tableHead" style="width: calc(100% / 9);" >Number of students per branch</p>
    <p i18n ngClass="tableHead" style="width: calc(100% / 9);" >Bank Name</p>
    <p i18n ngClass="tableHead" style="width: calc(100% / 9);" >Bank Account Name</p>
    <p i18n ngClass="tableHead" style="width: calc(100% / 9);" >Bank Account Number</p>
    <p i18n ngClass="tableHead" style="width: calc(100% / 9);" >Account Currency</p>
    <p i18n ngClass="tableHead" style="width: calc(100% / 9);" >SWIFT Code</p>



  </div>
  <table style="width: 1075px;" mat-table *ngIf="dataSource?.data != null && dataSource?.data.length > 0" [dataSource]="dataSource" >
    <ng-container  matColumnDef="branchNumber">
      <td mat-cell *matCellDef="let row" style="margin: 0;padding: 0;padding-right: 8px">{{row.branchNumber}}</td>
    </ng-container>
    <ng-container  matColumnDef="branchNameEn">
      <td mat-cell *matCellDef="let row" style="margin: 0;padding: 0;padding-right: 8px">{{row.branchNameEN}}
      </td>
    </ng-container>
    <ng-container  matColumnDef="branchNameAr">
      <td mat-cell *matCellDef="let row" style="margin: 0;padding: 0;padding-right: 8px">{{row.branchNameAR }}</td>
    </ng-container>
    <ng-container matColumnDef="numberOfStudentsPerBranch">
      <td mat-cell *matCellDef="let row" style="margin: 0;padding: 0;padding-right: 8px">
      {{row.numberOfStudentsPerBranch}}

      </td>
    </ng-container>
 ]
    <ng-container  matColumnDef="bankName">
      <td mat-cell *matCellDef="let row" style="margin: 0;padding: 0;padding-right: 8px">{{row.bankName }}</td>
    </ng-container>
    <ng-container  matColumnDef="bankAccountName">
      <td mat-cell *matCellDef="let row" style="margin: 0;padding: 0;padding-right: 8px">{{row.bankAccountName }}</td>
    </ng-container>
    <ng-container  matColumnDef="bankAccountNumber">
      <td mat-cell *matCellDef="let row" style="margin: 0;padding: 0;padding-right: 8px">{{row.bankAccountNumber }}</td>
    </ng-container>
    <ng-container  matColumnDef="accountCurrency">
      <td mat-cell *matCellDef="let row" style="margin: 0;padding: 0;padding-right: 8px">{{row.accountCurrency }}</td>
    </ng-container>
    <ng-container  matColumnDef="SWIFTcode">
      <td mat-cell *matCellDef="let row" style="margin: 0;padding: 0;padding-right: 8px">{{row.SWIFTcode }}</td>
    </ng-container>


    <tr mat-row  *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

</div>
 <div (click)="openAddBranchDialog()" class="addBranch" >
  <img   src="../../../assets/images/PlusIcon.svg"  alt=""/>
  <p style="font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  font-size: 16px;font-weight: 700;color: rgba(133, 60, 247, 1);" >
     Add Branch</p>
 </div>

</div>
 <div  class="nextButton" (click)="onNext()" >
    Next
 </div>



    </div>

   <div *ngIf="activeIndex==3" class="section">
    <p class="sectionTitle" >Required documents</p>
    <div class="uploadFilesSubSection">
      <div class="subtitle">
        Please upload the below documents يرجي رفع المستندات الاتية
      </div>
      <div class="subrow">
        <div class="subrowText">
          1. Recent Commercial Register (Issued within the last 2 months) - سجل تجاري حديث (مصدر خلال اخر شهرين)
        </div>
        <div *ngIf="!fileCommercial" class="uploadFile" (click)="fileInputCommercial.click()" >
          <img src="../../../assets/images/exportFile.svg" alt="">
          <p class="uploadFileText" > Upload File </p>
          <input type="file" #fileInputCommercial style="display:none" (change)="onFileSelected($event, 'fileCommercial')">
        </div>
        <div *ngIf="fileCommercial" class="selectedFile">
          <img src="../../../assets/images/fileIcon.svg" alt="">
          <div style="font-size: 16px;font-weight: 400;color: #4D4D4D;" >{{ fileCommercial.name }}</div>
          <img height="10" width="10" style="cursor: pointer;" (click)="deleteFile('fileCommercial')" src="../../../assets/images/Closex.svg" alt="">
        </div>

      </div>
      <div class="subrow">
        <div class="subrowText">
          2. Valid Tax Card - بطاقة ضريبية سارية
        </div>
        <div *ngIf="!fileTax" class="uploadFile" (click)="fileInputTax.click()" >
          <img src="../../../assets/images/exportFile.svg" alt="">
          <p class="uploadFileText" > Upload File </p>
          <input type="file" #fileInputTax style="display:none" (change)="onFileSelected($event, 'fileTax')">
        </div>
        <div *ngIf="fileTax" class="selectedFile">
          <img src="../../../assets/images/fileIcon.svg" alt="">
          <div style="font-size: 16px;font-weight: 400;color: #4D4D4D;" >{{ fileTax.name }}</div>
          <img height="10" width="10" style="cursor: pointer;" (click)="deleteFile('fileTax')" src="../../../assets/images/Closex.svg" alt="">
        </div>

      </div>
      <div class="subrow">
        <div class="subrowText">
          3. Authorized Signatory ID - بطاقة الشخص المسئول
        </div>
        <div *ngIf="!fileAuthorized" class="uploadFile" (click)="fileInputAuthorized.click()" >
          <img src="../../../assets/images/exportFile.svg" alt="">
          <p class="uploadFileText" > Upload File </p>
          <input type="file" #fileInputAuthorized style="display:none" (change)="onFileSelected($event, 'fileAuthorized')">
        </div>
        <div *ngIf="fileAuthorized" class="selectedFile">
          <img src="../../../assets/images/fileIcon.svg" alt="">
          <div style="font-size: 16px;font-weight: 400;color: #4D4D4D;" >{{ fileAuthorized.name }}</div>
          <img height="10" width="10" style="cursor: pointer;" src="../../../assets/images/Closex.svg" (click)="deleteFile('fileAuthorized')" alt="">
        </div>

      </div>

    </div>
    <div class="submitAndReview">
      <div class="nextButton" routerLink="/registrationsuccess">Submit</div>
      <p style="background: #D8D8D8;cursor: pointer;" class="uploadFileText" (click)="reviewMode()" >Review</p>
    </div>



   </div>




  </div>

  <div style="padding-left: 84px;padding-top: 32px;padding-bottom: 84px;" *ngIf="review" class="review">
    <img  style="z-index: 10000;margin-bottom: 16px;cursor: pointer;" src="../../../assets/images/arrowBack.svg" (click)="onBackFromReview()" alt=""/>


      <div  class="section" >
        <p class="sectionTitle" >General Information بيانات عامة</p>
        <div  class="subsection">
        <p class="formLabel">
          Education institution Name - اسم المنشأة التعليمية/الاسم التجاري
            </p>
            <!-- <mat-form-field  class="formFieldMaro"  [hideRequiredMarker]="true" appearance="outline">

              <input matInput placeholder="Student Id" style="border: grey;color: yellow;" >

            </mat-form-field> -->
            <input class="formFieldMaro"  >
          </div>
          <div class="subsection">
            <p class="formLabel">
              Company Name - اسم الشركة (As Per The Commercial Register - مطابق للسجل التجاري)
                </p>
                <input class="formFieldMaro"  >
          </div>
          <div class="subsection">
            <p class="formLabel">
              Authorized Person - الشخص المفوض (As Per The Commercial Register - مطابق للسجل التجاري)
                </p>
                <input class="formFieldMaro"    >
          </div>
          <div class="subsection">
            <p class="formLabel">
              Title - المنصب
                </p>
                <input class="formFieldMaro"    >
          </div>
          <div class="subsection">
            <p class="formLabel">
              Commercial Register Number - رقم السجل التجاري (As Per The Commercial Register - مطابق للسجل التجاري)
                </p>
                <input class="formFieldMaro"    >
          </div>
          <div class="subsection">
            <p class="formLabel">
              Tax Card Number - رقم البطاقة الضریبیة (As Per The Tax ID - مطابق للبطاقة الضریبیة)
                </p>
                <input class="formFieldMaro"    >
          </div>
          <div class="subsection">
            <p class="formLabel">
              Company Address - عنوان الشركة (As Per The Commercial Register - مطابق للسجل التجاري)
                </p>
                <input class="formFieldMaro"    >
          </div>
          <p style="margin-top:8px ;" class="sectionTitle" >Business Activity بيانات نشاط الشركة</p>
          <div class="subsection">
            <p class="formLabel">
              Number of students that will be registered on the system - عدد الطلبة الذي سیتم تسجیلهم علي المنصة
                </p>
                <input class="formFieldMaro"  >

          </div>
          <div class="subsection">
            <p class="formLabel">
              Number of Branches - عدد الافرع
                </p>
                <input class="formFieldMaro"  >

          </div>
          <div class="subsection">
            <p class="formLabel">
              Average annual fees collected per student - متوسط المصروفات السنویة المحصلة من كل طالب
                </p>
                <input class="formFieldMaro"  >

          </div>



      </div>

      <div  class="section" >
        <p class="sectionTitle" style="margin-top: 24px;" >Financials Contact Person Details - بیانات مسئول الماليات</p>
        <div  class="subsection">
        <p class="formLabel">
          Name - الاسم
            </p>
            <input class="formFieldMaro"  >
          </div>
          <div class="subsection">
            <p class="formLabel">
              Mobile Number - رقم المحمول
                </p>
                <input class="formFieldMaro"  >
          </div>
          <div class="subsection">
            <p class="formLabel">
              Email - البرید الالكتروني
                </p>
                <input class="formFieldMaro"    >
          </div>

          <p style="margin-top:8px ;" class="sectionTitle" >Notices - الاخطارات</p>
          <div class="subsection">
            <p class="formLabel">
              Notices Address - عنوان الاخطارات
                </p>
                <input class="formFieldMaro"  >

          </div>
          <div class="subsection">
            <p class="formLabel">
              Contact Person - الشخص المسئول
                </p>
                <input class="formFieldMaro"  >

          </div>
          <div class="subsection">
            <p class="formLabel">
              Mobile Number - رقم المحمول
                </p>
                <input class="formFieldMaro"  >

          </div>
          <div class="subsection">
            <p class="formLabel">
              Email - البرید الالكتروني
                </p>
                <input class="formFieldMaro"  >

          </div>

      </div>

      <div  class="section">
        <p class="sectionTitle" style="margin-top: 24px;" >Branches Bank Info</p>
        <div class="tableBackground" >
  <div class="tableBox none" style="width: 100%; display: flex; justify-content: center; flex-direction: column;">


    <div #sourceWidth ngClass="tableTitles" *ngIf="dataSource?.data != null && dataSource?.data.length > 0">
      <p i18n ngClass="tableHead" style="width: calc(100% / 9);" >Branch Number</p>
      <p i18n ngClass="tableHead" style="width: calc(100% / 9);" >Branch Name-English</p>
      <p i18n ngClass="tableHead" style="width: calc(100% / 9);" >اسم الفرع بالعربية</p>
      <p i18n ngClass="tableHead" style="width: calc(100% / 9);" >Number of students per branch</p>
      <p i18n ngClass="tableHead" style="width: calc(100% / 9);" >Bank Name</p>
      <p i18n ngClass="tableHead" style="width: calc(100% / 9);" >Bank Account Name</p>
      <p i18n ngClass="tableHead" style="width: calc(100% / 9);" >Bank Account Number</p>
      <p i18n ngClass="tableHead" style="width: calc(100% / 9);" >Account Currency</p>
      <p i18n ngClass="tableHead" style="width: calc(100% / 9);" >SWIFT Code</p>



    </div>
    <table style="width: 1075px;" mat-table *ngIf="dataSource?.data != null && dataSource?.data.length > 0" [dataSource]="dataSource" >
      <ng-container  matColumnDef="branchNumber">
        <td mat-cell *matCellDef="let row" style="margin: 0;padding: 0;padding-right: 8px">{{row.branchNumber}}</td>
      </ng-container>
      <ng-container  matColumnDef="branchNameEn">
        <td mat-cell *matCellDef="let row" style="margin: 0;padding: 0;padding-right: 8px">{{row.branchNameEN}}
        </td>
      </ng-container>
      <ng-container  matColumnDef="branchNameAr">
        <td mat-cell *matCellDef="let row" style="margin: 0;padding: 0;padding-right: 8px">{{row.branchNameAR }}</td>
      </ng-container>
      <ng-container matColumnDef="numberOfStudentsPerBranch">
        <td mat-cell *matCellDef="let row" style="margin: 0;padding: 0;padding-right: 8px">
        {{row.numberOfStudentsPerBranch}}

        </td>
      </ng-container>
   ]
      <ng-container  matColumnDef="bankName">
        <td mat-cell *matCellDef="let row" style="margin: 0;padding: 0;padding-right: 8px">{{row.bankName }}</td>
      </ng-container>
      <ng-container  matColumnDef="bankAccountName">
        <td mat-cell *matCellDef="let row" style="margin: 0;padding: 0;padding-right: 8px">{{row.bankAccountName }}</td>
      </ng-container>
      <ng-container  matColumnDef="bankAccountNumber">
        <td mat-cell *matCellDef="let row" style="margin: 0;padding: 0;padding-right: 8px">{{row.bankAccountNumber }}</td>
      </ng-container>
      <ng-container  matColumnDef="accountCurrency">
        <td mat-cell *matCellDef="let row" style="margin: 0;padding: 0;padding-right: 8px">{{row.accountCurrency }}</td>
      </ng-container>
      <ng-container  matColumnDef="SWIFTcode">
        <td mat-cell *matCellDef="let row" style="margin: 0;padding: 0;padding-right: 8px">{{row.SWIFTcode }}</td>
      </ng-container>


      <tr mat-row  *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

  </div>
   <!-- <div (click)="openAddBranchDialog()" class="addBranch" >
    <img   src="../../../assets/images/PlusIcon.svg"  alt=""/>
    <p style="font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
    font-size: 16px;font-weight: 700;color: rgba(133, 60, 247, 1);" >
       Add Branch</p>
   </div> -->

  </div>




      </div>

     <div class="section">
      <p class="sectionTitle" style="margin-top: 24px;" >Required documents</p>
      <div class="uploadFilesSubSection">
        <div class="subtitle">
          Please upload the below documents يرجي رفع المستندات الاتية
        </div>
        <div class="subrow">
          <div class="subrowText">
            1. Recent Commercial Register (Issued within the last 2 months) - سجل تجاري حديث (مصدر خلال اخر شهرين)
          </div>
          <div *ngIf="!fileCommercial" class="uploadFile" (click)="fileInputCommercial.click()" >
            <img src="../../../assets/images/exportFile.svg" alt="">
            <p class="uploadFileText" > Upload File </p>
            <input type="file" #fileInputCommercial style="display:none" (change)="onFileSelected($event, 'fileCommercial')">
          </div>
          <div *ngIf="fileCommercial" class="selectedFile">
            <img src="../../../assets/images/fileIcon.svg" alt="">
            <div style="font-size: 16px;font-weight: 400;color: #4D4D4D;" >{{ fileCommercial.name }}</div>
            <img height="10" width="10" style="cursor: pointer;" (click)="deleteFile('fileCommercial')" src="../../../assets/images/Closex.svg" alt="">
          </div>

        </div>
        <div class="subrow">
          <div class="subrowText">
            2. Valid Tax Card - بطاقة ضريبية سارية
          </div>
          <div *ngIf="!fileTax" class="uploadFile" (click)="fileInputTax.click()" >
            <img src="../../../assets/images/exportFile.svg" alt="">
            <p class="uploadFileText" > Upload File </p>
            <input type="file" #fileInputTax style="display:none" (change)="onFileSelected($event, 'fileTax')">
          </div>
          <div *ngIf="fileTax" class="selectedFile">
            <img src="../../../assets/images/fileIcon.svg" alt="">
            <div style="font-size: 16px;font-weight: 400;color: #4D4D4D;" >{{ fileTax.name }}</div>
            <img height="10" width="10" style="cursor: pointer;" (click)="deleteFile('fileTax')" src="../../../assets/images/Closex.svg" alt="">
          </div>

        </div>
        <div class="subrow">
          <div class="subrowText">
            3. Authorized Signatory ID - بطاقة الشخص المسئول
          </div>
          <div *ngIf="!fileAuthorized" class="uploadFile" (click)="fileInputAuthorized.click()" >
            <img src="../../../assets/images/exportFile.svg" alt="">
            <p class="uploadFileText" > Upload File </p>
            <input type="file" #fileInputAuthorized style="display:none" (change)="onFileSelected($event, 'fileAuthorized')">
          </div>
          <div *ngIf="fileAuthorized" class="selectedFile">
            <img src="../../../assets/images/fileIcon.svg" alt="">
            <div style="font-size: 16px;font-weight: 400;color: #4D4D4D;" >{{ fileAuthorized.name }}</div>
            <img height="10" width="10" style="cursor: pointer;" src="../../../assets/images/Closex.svg" (click)="deleteFile('fileAuthorized')" alt="">
          </div>

        </div>

      </div>
      <div class="submitAndReview">
        <div class="nextButton" routerLink="/registrationsuccess" >Submit</div>
        <!-- <p style=  "background: #D8D8D8;cursor: pointer;" class="uploadFileText" (click)="reviewMode()" >Review</p> -->
      </div>



     </div>





  </div>
</div>
